import react ,{useEffect} from 'react'
import { Col, Container, Form, FormControl, Row, InputGroup } from 'react-bootstrap'
import Section from '../../Utilitis/Section'
import { LoginSection, FormSection, SocialLogin, FormContainer, FormBtn } from './LoginStyle'
import { motion, AnimatePresence } from 'framer-motion';

export default function Login() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
            <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ duration: 0.3 }}
            >
                <Section bg="white">
                    <Container>
                        <LoginSection>
                            <Row>
                                <Col lg={8}>
                                    <img src={"/images/5_SCENE.svg"} alt="" />
                                </Col>
                                <Col lg={4}>
                                    <FormSection>
                                        <h5>Educate </h5>
                                        <h6>Log In</h6>
                                        <SocialLogin>
                                            <div>
                                                <img src={"images/google.png"} alt="" />
                                                <span>Google</span>
                                            </div>
                                            <div>
                                                <img src={"images/facebook.png"} alt="" />
                                                <span>Facbook</span>
                                            </div>
                                        </SocialLogin>
                                        <FormContainer>
                                            <Form>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Email address</Form.Label>
                                                    <InputGroup className="mb-2">
                                                        <InputGroup.Text>@</InputGroup.Text>
                                                        <FormControl id="inlineFormInputGroup" placeholder="Email" />
                                                    </InputGroup>
                                                </Form.Group>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Password</Form.Label>
                                                    <InputGroup className="mb-2">
                                                        <InputGroup.Text>
                                                            <i className="fas fa-lock"></i>
                                                        </InputGroup.Text>
                                                        <FormControl id="inlineFormInputGroup" placeholder="password" />
                                                    </InputGroup>
                                                </Form.Group>
                                                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                                    <Form.Check type="checkbox" label="remamber me!" />
                                                </Form.Group>
                                                <FormBtn variant="primary" type="submit">
                                                    Login
                                                </FormBtn>
                                                <p>Dont Have an Acount?<a href="#">New Acount</a></p>
                                            </Form>
                                        </FormContainer>
                                    </FormSection>
                                </Col>
                            </Row>
                        </LoginSection>
                    </Container>
                </Section>
            </motion.div>
    )
}
